// @flow
import styled from "styled-components";
import _Money from "../../Money";
import RawKuchka from "../../Icons/Kuchka";

// styled
const Flex = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
`;

export const Overlay = styled(Flex)`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  padding: 2.5em;
  font-size: 10px;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.75);
  user-select: none;
  z-index: 20000;

  @media (max-width: 959px) {
    padding: 1.5em;
    font-size: 8px;
  }
  @media (max-width: 567px) {
    font-size: 7px;
  }
`;

export const Popup = styled.div`
  direction: ${({ theme }) => theme.direction};
  position: relative;
  min-height: auto;
  width: 480px;
  padding: 35px 65px;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 18px;
  color: #96949b;
  text-align: center;
  background-color: ${({ theme }) => theme.mainHighlight};

  @media (min-width: 960px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    min-height: 328px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: ${({ nowrap }) => nowrap ? "nowrap" : "wrap"};
  align-items: center;
  align-content: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  height: ${({ nowrap }) => nowrap ? "auto" : "100%"};
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex: 1;
  width: 100%;
`;

export const Title = styled.h3`
  width: 100%;
  margin: 0 auto 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: ${({ theme }) => theme.foreground};
  text-align: center;

  @media (min-width: 960px) {
    max-width: 300px;
  }

  @media (max-width: 959px) and (min-width: 480px) {
    padding-right: 32px;
    padding-left: 32px;
  }
`;

export const CloseContainer = styled(Flex)`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 20px;
  height: 20px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: #96949b;
  transition: color 0.3s ease;

  :hover {
    color: ${({ theme }) => theme.foreground};
  }
`;

export const Footer = styled.div`
  padding-top: 9px;

  @media (max-width: 959px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
`;

export const MoneyContainer = styled.div`
  margin: 0 auto;
  margin-bottom: 26px;
  font-size: 32px;
  line-height: 38px;
  color: #99959d;

  @media (max-width: 959px) {
    text-align: center;
    font-size: 28px;
  }
  
  @media (max-height: 360px) {
    margin-bottom: 0;
  }
`;

export const Value = styled(_Money.Value)`
  font-weight: 700;
  margin: 0 2px;
  color: ${({ theme }) => theme.alternativeAccent};
`;

export const Currency = styled(_Money.Symbol)`
  font-weight: 700;
  margin: 0 2px;
  color: ${({ theme }) => theme.alternativeAccent};
`;

export const Kuchka = styled(RawKuchka)`
  font-weight: 700;
  margin: 0 2px;
  color: ${({ theme }) => theme.accent};
`;

export const Content = styled.p`
  margin-bottom: 20px;

  @media (max-width: 959px) {
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
    line-height: 1.5;
    color: #96949b;
    text-align: center;
  }
`;

export const Free = styled.span`
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme }) => theme.accent};
`;





// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/styles.js